import React from 'react';
import {
  Autocomplete,
  TextField,
  Typography,
  Box,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import ValidationErrorText from '../common/ValidationErrorText';

const DEFAULT_EXPERIENCE_OPTIONS = [
  'Not Required',
  '6 Months',
  '1 Year',
  '1.5 Years',
  '2 Years',
  '2.5 Years',
  '3 Years',
  '4 Years',
  '5 Years',
  '7+ Years',
  '10+ Years',
];

const WorkExperienceSelect = ({
  label = 'Work Experience',
  value = { isRequired: false, experience: '' },
  onChange = () => {},
  readOnly = false,
  options = DEFAULT_EXPERIENCE_OPTIONS,
  fieldError,
  fieldErrors,
  fieldType
}) => {
  const isRequired = !!value?.isRequired;
  const experience = value?.experience || '';

  const handleToggleRequired = (checked) => {
    onChange({ isRequired: checked, experience: checked ? experience : '' });
  };

  const handleExperienceChange = (_e, newVal) => {
    onChange({ isRequired, experience: newVal || '' });
  };

  return (
    <Box sx={{ minWidth: '100%' }}>
      {label && (
        <Typography fontSize="14px" fontWeight="500" mb={1}>
          {label}
        </Typography>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{width:"100%"}}>
        <Autocomplete
          options={options}
          value={experience || null}
          onChange={handleExperienceChange}
          fullWidth
          size="small"
          disabled={!isRequired || readOnly}
          clearOnBlur
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select experience"
              size="small"
              InputProps={{
                ...params.InputProps,
                sx: { fontSize: 13, height: 38, maxWidth: '300px' },
              }}
              inputProps={{
                ...params.inputProps,
                style: { fontSize: 13, padding: '8px 12px', maxWidth: '300px' },
              }}
            />
          )}
          sx={{
            maxWidth: '300px',
            '& .MuiAutocomplete-inputRoot': {
              padding: '0 !important',
              maxWidth: '300px',
            },
          }}
        />
        <ValidationErrorText error={fieldErrors?.[`${fieldType}.experience`]}/>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              checked={isRequired}
              onChange={(e) => handleToggleRequired(e.target.checked)}
              size="small"
              disabled={readOnly}
            />
          }
          label="(if applicable)"
          sx={{ margin: 0, whiteSpace: 'nowrap' }}
        />
      </Box>
    </Box>
  );
};

export default WorkExperienceSelect;
